(() => {
  const SELECTOR = '[data-rr-cs-animate="true"]';

  const reveal = (el) => {
    el.classList.add('is-visible');
  };

  const initAnimations = (root = document) => {
    const nodes = root.querySelectorAll(SELECTOR);
    if (!nodes.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      for (const el of nodes) {
        reveal(el);
      }
      return;
    }

    if (!('IntersectionObserver' in window)) {
      for (const el of nodes) {
        reveal(el);
      }
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          reveal(entry.target);
          obs.unobserve(entry.target);
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    for (const el of nodes) {
      if (el.classList.contains('is-visible')) continue;
      observer.observe(el);
    }
  };

  const init = (root = document) => {
    initAnimations(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
